module.exports = __webpack_public_path__ + "static/media/Dependent cameras_1.5fc5cdaa.png";